"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarningInfo = void 0;
const store_1 = require("client/modules/orders/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./warning-info.less");
let WarningInfo = class WarningInfo extends react_1.Component {
    constructor(props) {
        super(props);
        this.xml = "";
    }
    async componentDidMount() {
        if (this.props.params && this.props.params.length === 2) {
            await store_1.ordersStore.readClaim(parseInt(this.props.params[1], 10));
            const claim = store_1.ordersStore.claim.value;
            const ndc = claim && claim.inventory.package;
            const response = await fetch(`https://dailymed.nlm.nih.gov/dailymed/services/v2/spls?ndc=${ndc &&
                ndc.substring(1)}`);
            const setId = (await response.json()).data[0].setid;
            const warningInfoReponse = await fetch(`https://dailymed.nlm.nih.gov/dailymed/services/v2/spls/${setId}.xml`);
            this.xml = await warningInfoReponse.text();
        }
    }
    render() {
        return (React.createElement("div", { className: "warning-info" },
            React.createElement("pre", { className: "xml-body" }, this.xml)));
    }
};
__decorate([
    mobx_1.observable
], WarningInfo.prototype, "xml", void 0);
WarningInfo = __decorate([
    mobx_react_1.observer
], WarningInfo);
exports.WarningInfo = WarningInfo;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/order-claims/warning-info/warning-info.tsx
// module id = 3736
// module chunks = 0